/**
 * 区域数据模型（核心逻辑层）
 */
import { services } from '../services';

const CACHE_KEY = 'REGION_LIST';
const CACHE_EXPIRE = 24 * 60 * 60 * 1000; // 24小时缓存

export const RegionModel = {
  /**
   * 获取所有区域（带缓存+数据校验）
   * @returns {Promise<Array>} 格式化后的区域列表
   */
  getRegions: async () => {
    // 查缓存
    const cacheData = localStorage.getItem(CACHE_KEY);
    const cacheTime = localStorage.getItem(`${CACHE_KEY}_TIME`);
    if (cacheData && cacheTime && Date.now() - Number(cacheTime) < CACHE_EXPIRE) {
      // return JSON.parse(cacheData);
    }

    // 调用接口
    // const response = await services.region.getRegions();
    // if (!response.ok) throw new Error('区域接口请求失败');
    // const rawData = await response.json();

    const response = await services.region.getRegions();
    const data = await response.json();
    const rawData = data?.result ?? [];

    // 数据校验+格式化
    // const validData = RegionModel._validateList(rawData);

    // 存缓存
    localStorage.setItem(CACHE_KEY, JSON.stringify(rawData));
    localStorage.setItem(`${CACHE_KEY}_TIME`, Date.now().toString());

    return rawData;
  },

  /**
   * 过滤有效区域（业务逻辑：避免URL参数篡改）
   * @param {Array} regionList 所有区域列表
   * @param {Array} urlRegions URL中的区域参数（如["香洲区", "xxx"]）
   * @returns {Array} 有效区域列表
   */
  filterValidRegions: (regionList, urlRegions) => {
    if (!Array.isArray(urlRegions)) return [];
    return urlRegions.filter(region => regionList.includes(region.trim()));
  },

  /**
   * 私有方法：校验区域列表
   */
  _validateList: (rawList) => {
    if (!Array.isArray(rawList)) throw new Error('区域接口返回格式错误（非数组）');
    // 过滤空值、去重、格式化
    return Array.from(new Set(rawList))
      .filter(region => typeof region === 'string' && region.trim())
      .map(region => region.trim());
  }
};